<template>
  <div class="row">
    <div class="col order-quotable q-mr-md">
      <div class="row">
        <div :class="'col ' + (orderAnimationFlg ? 'order-quotable-trasform' : '')">
          <label>注文：&nbsp;</label>
          <span>{{ orderCnt }}</span>
        </div>
        <div
          v-if="poType === 'PO_NORMAL'"
          :class="'col ' + (quotableAnimationFlg ? 'order-quotable-trasform' : '')"
        >
          <label>問い合わせ：&nbsp;</label>
          <span>{{ quotableCnt }}</span>
        </div>
      </div>
    </div>
    <div class="col column justify-center" style="min-width: 150px">
      <q-btn
        class="order-quotable-btn"
        :label="poType === 'PO_NORMAL' ? '注文/問い合わせ' : 'ChemPanda カート'"
        :style="
          poType === 'PO_NORMAL'
            ? 'min-width: 150px; text-transform: none'
            : 'min-width: 162px; text-transform: none'
        "
        @click="orderQuotable"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { Ref, ref, inject, watch } from 'vue';
import { useRouter } from 'vue-router';
import countOrderQuotableKey from '../../common/order-quotable-key';

const router = useRouter();

const emit = defineEmits(['deleteSidebar']);

// 注文件数
const orderCnt = inject<Ref<number>>('orderCnt');

// 問い合わせ件数
const quotableCnt = inject<Ref<number>>('quotableCnt');

// パンチアウトタイプ
const poType = inject('poType');

// 注文件数アニメーションフラグ
const orderAnimationFlg = ref<boolean>(false);

// 問い合わせ件数アニメーションフラグ
const quotableAnimationFlg = ref<boolean>(false);

const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });

// 注文問い合わせ件数取得
const countOrderQuotable = inject(countOrderQuotableKey);

/**
 * 注文問い合わせ画面遷移
 */
const orderQuotable = () => {
  emit('deleteSidebar');
  router.push({ name: 'orderInquiry' });
};

// 初期表示処理
countOrderQuotable?.();

// 注文件数が変更されたか監視
watch(
  () => orderCnt?.value,
  async () => {
    orderAnimationFlg.value = true;
    await sleep(2);
    orderAnimationFlg.value = false;
  }
);

// 問い合わせ件数が変更されたか監視
watch(
  () => quotableCnt?.value,
  async () => {
    quotableAnimationFlg.value = true;
    await sleep(2);
    quotableAnimationFlg.value = false;
  }
);
</script>
<style scoped>
.order-quotable {
  font-size: 0.8rem;
  font-weight: 600;
  text-align: right;
}

.order-quotable .row {
  flex-direction: column;
}
.order-quotable span {
  font-size: 0.9rem;
}
.order-quotable-btn {
  background: var(--q-cart);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
}
</style>
<style>
button.order-quotable-btn.q-btn--actionable.q-btn--standard:after {
  content: '';
  background-color: rgba(255, 255, 255, 0.1);
  width: 147px;
  height: 18px;
  position: absolute;
  top: 0;
  left: 0;
}

@keyframes flash {
  /* 点滅 */
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.order-quotable-trasform span {
  animation: flash 1s linear infinite;
  transform: scale(1.5);
  display: inline-block;
}
</style>
